import React, { useState } from 'react';
import './Noticias.css';
import NewsCard from '../../components/NewsCard/NewsCard';

import Not1Img1 from '../../assets/noticias/noticia1_img1.jpg';
import Not1Img2 from '../../assets/noticias/noticia1_img2.jpg';
import Not1Doc1 from '../../assets/documents/1º Seminário Plano de Saneamento Básico - Paraisópolis.pdf';

import Not2Img1 from '../../assets/noticias/img1_not2.jpeg';
import Not2Img2 from '../../assets/noticias/img2_not2.jpeg';
import Not2Img3 from '../../assets/noticias/img3_not2.jpeg';
import Not2Img4 from '../../assets/noticias/img4_not2.jpeg';

const Noticias = () => {
  const handleDownload = async (filePath, fileName) => {
    try {
      // Busca o arquivo
      const response = await fetch(filePath);
      const blob = await response.blob();

      // Cria uma URL temporária para o blob
      const url = window.URL.createObjectURL(blob);

      // Cria o link de download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'download.pdf';
      document.body.appendChild(link);
      link.click();

      // Limpa
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      // Fallback: tenta download direto
      const link = document.createElement('a');
      link.href = filePath;
      link.download = fileName || 'download.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const [noticias] = useState([
    {
      id: 1,
      content: (
        <div>
          <h2>Confira como foi o Seminário da Cidade!</h2>
          <div className="text-justified paragraph-spaced"><br></br>
            <p>Na terça-feira, 9 de dezembro de 2025, às 19h, foi realizado o Seminário da Cidade, evento que marcou o início oficial da elaboração do Plano Municipal de Saneamento Básico de Paraisópolis, aberto à participação de toda a comunidade.</p>
            <p>Na ocasião, a equipe técnica da Fundação Theodomiro Santiago, vinculada à Universidade Federal de Itajubá (UNIFEI), apresentou aos presentes o conceito do Plano de Saneamento Básico, seus objetivos, diretrizes e a metodologia que orientará sua elaboração. Também foram detalhadas as etapas do trabalho, o cronograma previsto e, sobretudo, a relevância da participação popular em todas as fases do processo.</p>
          </div>

          <div className="images-row">
            <div className="image-with-caption">
              <img src={Not1Img1} alt="Seminário da Cidade" />
              {/* <div className="image-caption">Legenda da primeira imagem</div> */}
            </div>
            <div className="image-with-caption">
              <img src={Not1Img2} alt="Seminário da Cidade" />
              {/* <div className="image-caption">Legenda da segunda imagem</div> */}
            </div>
            <div className="images-group-caption">Evento Seminário da Cidade em Paraisópolis - MG.</div>
            <div className="images-caption">Evento Seminário da Cidade em Paraisópolis - MG.</div>
          </div>

          <div className="text-justified paragraph-spaced">
            <p>Durante o seminário, foi reforçado que a população pode contribuir não apenas participando dos encontros, mas também respondendo à pesquisa sobre os serviços de saneamento básico de Paraisópolis, disponível no site oficial e que, em breve, será distribuída em formato impresso em pontos estratégicos do município.</p>
            <p>A apresentação pode ser conferida abaixo ou, alternativamente, é possível acessar a página da Prefeitura de Consolação no Facebook, onde está disponível a transmissão completa do evento.</p>
            <p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownload(Not1Doc1, 'Seminário da Cidade - Apresentação.pdf');
                }}
                style={{ color: '#0066cc', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Baixar Apresentação do Seminário da Cidade (PDF)
              </a>
            </p>
            <p className="text-bold">Participe e ajude a construir o futuro do saneamento de Paraisópolis!</p>
          </div>
        </div>
      )
    },
    {
      id: 2,
      content: (
        <div>
          <h2>Audiência Pública reúne população para discussão do diagnóstico do Plano Municipal de Saneamento Básico de Paraisópolis</h2>
          <div className="text-justified paragraph-spaced"><br></br>
            <p>A Audiência Pública de apresentação do Diagnóstico Técnico e Participativo do Plano Municipal de Saneamento Básico (PMSB) foi realizada no dia 2 de junho de 2026, na Câmara Municipal de Paraisópolis, contando também com transmissão ao vivo pelos canais oficiais da Câmara.</p>
            <p>Durante o encontro, a equipe técnica apresentou os resultados do diagnóstico dos serviços de abastecimento de água, esgotamento sanitário, drenagem urbana e manejo de resíduos sólidos, além dos resultados das pesquisas realizadas com a população.</p>
            <p>Na sequência, os participantes puderam apresentar dúvidas, sugestões e contribuições sobre o saneamento no município. Entre os principais temas debatidos destacaram-se a operação da Estação de Tratamento de Esgoto (ETE), a necessidade de separação das redes de esgoto e drenagem pluvial, problemas de alagamentos, descarte irregular de resíduos sólidos, passivos ambientais dos antigos aterros e melhorias na infraestrutura de saneamento.</p>
            <p>As contribuições registradas durante a audiência serão consideradas na elaboração das propostas do Plano Municipal de Saneamento Básico, fortalecendo o planejamento das ações futuras para o município.</p>
          </div>

          <div className="images-row">
            <div className="image-with-caption">
              <img src={Not2Img1} alt="Audiência Pública" />
              {/* <div className="image-caption">Legenda da primeira imagem</div> */}
            </div>
            <div className="image-with-caption">
              <img src={Not2Img2} alt="Audiência Pública" />
              {/* <div className="image-caption">Legenda da segunda imagem</div> */}
            </div>
            <div className="image-with-caption">
              <img src={Not2Img3} alt="Audiência Pública" />
              {/* <div className="image-caption">Legenda da primeira imagem</div> */}
            </div>
            <div className="image-with-caption">
              <img src={Not2Img4} alt="Audiência Pública" />
              {/* <div className="image-caption">Legenda da segunda imagem</div> */}
            </div>
            <div className="images-group-caption">Evento Audiência Pública em Paraisópolis - MG.</div>
            <div className="images-caption">Evento Audiência Pública em Paraisópolis - MG.</div>
          </div>

        </div>
      )
    }
  ]);

  return (
    <div className="news-page">
      <section className="page-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Notícias</span>
          <p className="page-hero__description">Fique por dentro do que acontece no Plano Municipal de Saneamento Básico.</p>
        </div>
      </section>

      <section className="news-content">
        {noticias.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            color: '#666',
            fontSize: '1.125rem'
          }}>
            <p>Por enquanto não há notícias disponíveis.</p>
            <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
              Em breve, você encontrará aqui informações sobre o Plano Municipal de Saneamento Básico.
            </p>
          </div>
        ) : (
          noticias.map((noticia) => (
            <NewsCard key={noticia.id} noticia={noticia} />
          ))
        )}
      </section>
    </div>
  );
};

export default Noticias;
